import PropTypes from 'prop-types';
import React from 'react';
import ShareLinkModal from './ShareLinkModal';

const ShareFolderModal = ({ team, folder, csrfToken, onClose }) => (
  <ShareLinkModal
    title="Share Folder"
    description="Anyone with the link can access this folder and its contents."
    endpoint={`/teams/${team.id}/folders/${folder.id}`}
    resourceKey="folder"
    csrfToken={csrfToken}
    onClose={onClose}
    showAccessLevel
  />
);

ShareFolderModal.propTypes = {
  team: PropTypes.object.isRequired,
  folder: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ShareFolderModal;
